// ANIMATION BLOCK COMPANY

var lContentBloc = document.querySelector('#left-content-bloc');

window.addEventListener('scroll', function() {
    //var scrollPos = window.scrollY;
    if(window.innerWidth > 1023) {
        if(lContentBloc.getBoundingClientRect().top < window.innerHeight - 500 ) {
            company.classList.add('anim-section');
        }
        if(lContentBloc.getBoundingClientRect().bottom < 500) {
            company.classList.remove('anim-section');
        }
        if(lContentBloc.getBoundingClientRect().top > window.innerHeight - 500) {
            company.classList.remove('anim-section');
        }
    }
});

$('#left-content-bloc .cta').on("mouseover",function(){ 
    $('.content-group.left').addClass("hover-in");
    $(this).addClass('hover-in'); 
});                           
$('#left-content-bloc .cta').on("mouseout",function(){ 
    $('.content-group.left').removeClass("hover-in");
    $(this).removeClass('hover-in');  
});

$('#right-content-bloc .cta').on("mouseover",function(){ 
    $('.content-group.right').addClass("hover-in");
    $(this).addClass('hover-in'); 
});                           
$('#right-content-bloc .cta').on("mouseout",function(){ 
    $('.content-group.right').removeClass("hover-in");
    $(this).removeClass('hover-in');  
});

window.addEventListener("load", function() {
    /* IMMOADVISOR */
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", "https://api.immodvisor.com/company/express?id=30056&key=CTGN-XQV0I-9VAH-SCT88L-M7N2A", true);
    //xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhttp.onreadystatechange = function() {
       if (this.readyState == 4 && this.status == 200) {
    
          // Response
          var response = JSON.parse(this.response); 
          var rating = response.datas.rating ;
          var roundedRating =  Math.round(response.datas.rating * 2)*0.5;
          const starTotal = 5;
          const starPercentage = (roundedRating / starTotal) * 100;
          const starPercentageRounded = `${(Math.round(starPercentage / 10) * 10)}%`;
          document.querySelector(`.stars-inner`).style.width = starPercentageRounded;
          document.getElementById('rating').textContent = rating + ' / 5'
          document.getElementById('advisor').href = response.datas.link;
          document.getElementById('advisor').style.opacity = 1
    
       }
    };
    xhttp.send();
    
});

// NAV 
var header =  document.getElementById('common-nav');
var burgerWhite = header.querySelector('nav').children[0];
var burgerBlue = header.querySelector('nav').children[1];

window.addEventListener('scroll', function() {
    var scrollPos = window.scrollY;
    
    if(scrollPos >=10) {
        header.classList.add('scrollnav');
        burgerWhite.classList.add('d-none');
        burgerBlue.classList.remove('d-none');
    }
    else {
        header.classList.remove('scrollnav');
        burgerWhite.classList.remove('d-none');
        burgerBlue.classList.add('d-none');
    }
    
});